export const isActiveLink = (pathname, href, match) => {
  if (match === 'exact') {
    return pathname === href
  }
  if (match === 'startsWith') {
    return pathname.startsWith(href)
  }
  if (match === 'endsWith') {
    return pathname.endsWith(href)
  }
  return pathname.includes(href)
}
